import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnmatched = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.5 2H11.5C12.881 2 14 3.119 14 4.5V11.5C14 12.881 12.881 14 11.5 14H4.5C3.119 14 2 12.881 2 11.5V4.5C2 3.119 3.119 2 4.5 2Z",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.082 8.09L5.712 8.462C5.208 8.966 5.208 9.783 5.712 10.287C6.216 10.791 7.033 10.791 7.537 10.287L7.907 9.915L8.614 10.622L8.244 10.994L8.07 11.152C7.231 11.836 6.018 11.837 5.179 11.153L5.005 10.994C4.166 10.156 4.114 8.829 4.848 7.929L5.005 7.755L5.375 7.383L6.082 8.09ZM5.213 5.183C5.408 4.988 5.725 4.988 5.92 5.183L10.816 10.079C11.012 10.275 11.012 10.591 10.816 10.786C10.621 10.982 10.305 10.982 10.109 10.786L5.213 5.89C5.018 5.695 5.018 5.378 5.213 5.183ZM7.93 4.847C8.829 4.114 10.156 4.167 10.994 5.005L11.152 5.179C11.837 6.018 11.837 7.23 11.152 8.07L10.994 8.243L10.651 8.585L9.944 7.878L10.287 7.536C10.791 7.032 10.791 6.216 10.287 5.712C9.783 5.208 8.966 5.207 8.462 5.711L8.119 6.053L7.412 5.346L7.755 5.004L7.93 4.847Z",
		fill: "currentColor"
	})]
});
export default SvgUnmatched;
